var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ctrl-notifications"},[_c('h2',[_vm._v("全体連絡 一覧")]),_c('NotificationList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }